const Distribution = () => {
    return (
    <div>
     <div className="">
        <img src="/logisticsBanner/banner-4.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem]"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
        
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
              Distribution
            </h1>
            <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Getting the stocks to retail markets and shops within the urban sprawl and in far flung areas fall 
              in the realms of secondary distribution, a segment that remains a weak link in supply chain. This weak 
              link is in focus at TCS as a separate entity for the purpose with the nomenclature TCS Distribution.
            </p>
            <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              Our extensive nationwide network enables you for a priceless penetration of Pakistan's social 
              and economic landscape. TCS Distribution is fully leveraging this fact to service corporate manufacturers 
              by making possible for them an outreach that competitors in the retail distribution sector are unable to match. 
              Such as:
            </p>
            <p className="text-sm text-md lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              • Cost-effective services for modern trade <br/>
              • Speedy & timely services for retail stores <br/>
              • End to End visibility of order management <br/>
              • Easy to track and trace shipment <br/>
              • JIT & Milk run services for auto sector <br/>
              •	Inventory Management    
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
    </div>
    

  )
};
export default Distribution;